import { resolveSetOptions } from './set-variants.mjs';
import { metalSwatch } from './metal-swatch.mjs';

/** Radio controls enhance native selects; WooCommerce still resolves and validates the variation. */
export const enhanceProductOptions = (form, config, onChange) => {
    const $ = window.jQuery;
    const selects = [...form.querySelectorAll('.variations select[name^="attribute_"]')];
    if (!selects.length || !$?.fn.wc_variation_form) return;
    const payload = $(form).data('product_variations');
    const variants = Array.isArray(payload) ? payload.filter((variant) => variant.is_in_stock && variant.is_purchasable && variant.variation_is_active)
        .map((variant) => ({ ...variant, id: variant.variation_id })) : null;
    const host = document.createElement('div');
    host.className = 'ProductOptions';
    const fields = selects.map((select) => {
        const name = select.name;
        const metal = name === 'attribute_pa_kolor-metalu';
        const options = [...select.options].filter((option) => option.value).map((option) => ({ value: option.value, label: option.textContent }));
        // Numeric sizes should read 5, 6, …, 10; named attributes retain the editor's order.
        if (options.every((option) => /^\d+(?:[.,]\d+)?$/.test(option.label.trim()))) {
            options.sort((a, b) => Number(a.label.trim().replace(',', '.')) - Number(b.label.trim().replace(',', '.')));
        }
        const fieldset = document.createElement('fieldset');
        fieldset.className = `ProductOptions__group${metal ? ' ProductOptions__group--metal' : ''}`;
        const legend = document.createElement('legend');
        legend.className = 'ProductOptions__legend';
        const nativeLabel = select.closest('tr')?.querySelector('label')?.cloneNode(true);
        nativeLabel?.querySelectorAll('.woo-selected-variation-item-name').forEach((node) => node.remove());
        legend.textContent = nativeLabel?.textContent.trim() || select.name;
        const choices = document.createElement('div');
        choices.className = 'ProductOptions__choices';
        const inputs = options.map((option) => {
            const label = document.createElement('label');
            label.className = 'ProductOptions__choice';
            const input = document.createElement('input');
            Object.assign(input, { type: 'radio', name: `pdp_${name}`, value: option.value, checked: select.value === option.value, className: 'ProductOptions__input' });
            const content = document.createElement('span');
            content.className = 'ProductOptions__label';
            const swatch = metal ? metalSwatch(option.value) : null;
            if (swatch) {
                const image = document.createElement('img');
                Object.assign(image, { src: `${config.assets}product/metal-${swatch}.svg`, width: 24, height: 24, alt: '' });
                content.append(image);
            }
            content.append(document.createTextNode(option.label));
            label.append(input, content); choices.append(label);
            return input;
        });
        fieldset.append(legend, choices); host.append(fieldset);
        return { name, select, options: options.map(({ value }) => value), inputs, original: select.innerHTML };
    });
    const attributes = fields.map(({ name, options }) => ({ name, options }));
    const selections = () => Object.fromEntries(fields.map(({ name, select }) => [name, select.value]));
    const synchronize = () => {
        const available = variants ? resolveSetOptions(variants, attributes, selections()).available : null;
        fields.forEach(({ name, select, inputs }) => inputs.forEach((input) => {
            const option = [...select.options].find((item) => item.value === input.value);
            input.checked = select.value === input.value;
            input.disabled = available ? !available[name].includes(input.value) : !option || option.disabled;
        }));
    };
    host.addEventListener('change', (event) => {
        const field = fields.find(({ inputs }) => inputs.includes(event.target));
        if (!field) return;
        const values = { ...selections(), [field.name]: event.target.value };
        const resolved = variants ? resolveSetOptions(variants, attributes, values).selections : values;
        // Restore choices before updating; WooCommerce may have removed combinations for the previous choice.
        fields.forEach(({ select, name, original }) => { select.innerHTML = original; select.value = resolved[name] || ''; });
        $(field.select).trigger('change');
        synchronize(); onChange();
    });
    form.prepend(host);
    $(form).on('woocommerce_update_variation_values.ovaliaOptions found_variation.ovaliaOptions reset_data.ovaliaOptions', synchronize);
    form.addEventListener('change', synchronize);
    synchronize();
    return host;
};
